import {useState, useCallback} from "react"
import Participant from "../library/Participant"

interface UseParticipantResult {
  participant: Participant
  setParticipant: (participant: Participant) => void
}

export function useParticipant(presetCode: string): UseParticipantResult {
  const [participant, setParticipantState] = useState<Participant>(() =>
    Participant.findOrCreateNew(presetCode)
  )

  const setParticipant = useCallback((newParticipant: Participant) => {
    newParticipant.save(presetCode)
    setParticipantState(newParticipant)
  }, [presetCode])

  return {participant, setParticipant}
}